<template>
    <div v-if="environment != 'PROD'">
		<div class="version-tag version-tag--beta">{{ `${environment} version` }}</div>
	</div>

	<!-- <ExportFactory/>-->
	<MessageBox/>
	<DocumentViewer/>
	<router-view />
</template>

<script setup lang="ts">
    import { MessageBox } from "fw4-library";
    import { DocumentViewer } from "fw4-library";

    const environment = import.meta.env.MODE;
</script>

<!-- We need this tag for styles to work properly -->
<style lang="scss">
    
</style>
